import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=7612fa24&scoped=true"
import script from "./LegalNotice.vue?vue&type=script&lang=ts"
export * from "./LegalNotice.vue?vue&type=script&lang=ts"
import style0 from "./LegalNotice.vue?vue&type=style&index=0&id=7612fa24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7612fa24",
  null
  
)

export default component.exports